import React, { createElement } from 'react';
import { Button } from '../components/ui/Button';
import { Download } from 'lucide-react';
const svgColorStacked = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" width="100%" height="100%">
  <g transform="translate(120, 50)">
    <rect x="-24" y="-36" width="48" height="48" rx="10" fill="#0d9488" />
    <text x="0" y="-2" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
  </g>
  <text x="120" y="95" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" text-anchor="middle" letter-spacing="-0.02em">
    <tspan fill="#111827">Dentico</tspan><tspan fill="#0d9488">Clinic</tspan>
  </text>
  <text x="120" y="120" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="#6b7280" letter-spacing="0.25em" text-anchor="middle">PRIVATE DENTISTRY</text>
</svg>`;
const svgWhiteStacked = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" width="100%" height="100%">
  <g transform="translate(120, 50)">
    <rect x="-24" y="-36" width="48" height="48" rx="10" fill="#ffffff" />
    <text x="0" y="-2" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#111827" text-anchor="middle">D</text>
  </g>
  <text x="120" y="95" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" fill="#ffffff" text-anchor="middle" letter-spacing="-0.02em">DenticoClinic</text>
  <text x="120" y="120" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="rgba(255,255,255,0.8)" letter-spacing="0.25em" text-anchor="middle">PRIVATE DENTISTRY</text>
</svg>`;
const svgDarkStacked = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" width="100%" height="100%">
  <g transform="translate(120, 50)">
    <rect x="-24" y="-36" width="48" height="48" rx="10" fill="#111827" />
    <text x="0" y="-2" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
  </g>
  <text x="120" y="95" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" fill="#111827" text-anchor="middle" letter-spacing="-0.02em">DenticoClinic</text>
  <text x="120" y="120" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="#6b7280" letter-spacing="0.25em" text-anchor="middle">PRIVATE DENTISTRY</text>
</svg>`;
const svgIconOnly = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%">
  <rect x="10" y="10" width="80" height="80" rx="16" fill="#0d9488" />
  <text x="50" y="66" font-family="system-ui, -apple-system, sans-serif" font-size="48" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
</svg>`;
const svgHorizontal = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 100" width="100%" height="100%">
  <g transform="translate(20, 50)">
    <rect x="0" y="-24" width="48" height="48" rx="10" fill="#0d9488" />
    <text x="24" y="10" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
  </g>
  <text x="85" y="48" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" text-anchor="start" letter-spacing="-0.02em">
    <tspan fill="#111827">Dentico</tspan><tspan fill="#0d9488">Clinic</tspan>
  </text>
  <text x="87" y="70" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="#6b7280" letter-spacing="0.25em" text-anchor="start">PRIVATE DENTISTRY</text>
</svg>`;
export function LogoPage() {
  const downloadSvg = (svgString: string, filename: string) => {
    const blob = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-2472">
      <div className="max-w-5xl mx-auto" data-id="element-2473">
        {/* Header */}
        <div className="mb-12 text-center" data-id="element-2474">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2475">
            Dentico Clinic — Logo Kit
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2476">
            Download logos for websites, business cards, and print materials.
            All files are provided in vector SVG format for infinite
            scalability.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2477">
          {/* Variant 1: Full Color */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2478">
            <div className="h-64 bg-white flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2479">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-2480">
                Preview
              </div>
              <div className="w-full h-full" dangerouslySetInnerHTML={{
              __html: svgColorStacked
            }} data-id="element-2481" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2482">
              <div data-id="element-2483">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2484">
                  Full Color
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2485">Standard stacked layout</p>
              </div>
              <Button onClick={() => downloadSvg(svgColorStacked, 'dentico-logo-color.svg')} className="gap-2" data-id="element-2486">
                <Download className="w-4 h-4" data-id="element-2487" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 2: White on Dark */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2488">
            <div className="h-64 bg-[#1a1a2e] flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2489">
              <div className="absolute top-4 left-4 text-xs font-medium text-white/40 uppercase tracking-wider" data-id="element-2490">
                Preview
              </div>
              <div className="w-full h-full" dangerouslySetInnerHTML={{
              __html: svgWhiteStacked
            }} data-id="element-2491" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2492">
              <div data-id="element-2493">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2494">White</h3>
                <p className="text-sm text-gray-500" data-id="element-2495">For dark backgrounds</p>
              </div>
              <Button onClick={() => downloadSvg(svgWhiteStacked, 'dentico-logo-white.svg')} className="gap-2" data-id="element-2496">
                <Download className="w-4 h-4" data-id="element-2497" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 3: Dark Mono */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2498">
            <div className="h-64 bg-white flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2499">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-2500">
                Preview
              </div>
              <div className="w-full h-full" dangerouslySetInnerHTML={{
              __html: svgDarkStacked
            }} data-id="element-2501" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2502">
              <div data-id="element-2503">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2504">
                  Dark Mono
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2505">For light backgrounds</p>
              </div>
              <Button onClick={() => downloadSvg(svgDarkStacked, 'dentico-logo-dark.svg')} className="gap-2" data-id="element-2506">
                <Download className="w-4 h-4" data-id="element-2507" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 5: Horizontal */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2508">
            <div className="h-64 bg-white flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2509">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-2510">
                Preview
              </div>
              <div className="w-full h-full flex items-center" dangerouslySetInnerHTML={{
              __html: svgHorizontal
            }} data-id="element-2511" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2512">
              <div data-id="element-2513">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2514">
                  Horizontal
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2515">For headers and navbars</p>
              </div>
              <Button onClick={() => downloadSvg(svgHorizontal, 'dentico-logo-horizontal.svg')} className="gap-2" data-id="element-2516">
                <Download className="w-4 h-4" data-id="element-2517" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 4: Icon Only (Full Width) */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col md:col-span-2" data-id="element-2518">
            <div className="h-64 flex border-b border-gray-100 relative" data-id="element-2519">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider z-10" data-id="element-2520">
                Preview
              </div>
              {/* Light side */}
              <div className="w-1/2 bg-white flex items-center justify-center p-8" data-id="element-2521">
                <div className="w-32 h-32" dangerouslySetInnerHTML={{
                __html: svgIconOnly
              }} data-id="element-2522" />
              </div>
              {/* Dark side */}
              <div className="w-1/2 bg-[#1a1a2e] flex items-center justify-center p-8" data-id="element-2523">
                <div className="w-32 h-32" dangerouslySetInnerHTML={{
                __html: svgIconOnly
              }} data-id="element-2524" />
              </div>
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50" data-id="element-2525">
              <div data-id="element-2526">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2527">
                  Icon Only
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2528">
                  For avatars, favicons, and social media
                </p>
              </div>
              <Button onClick={() => downloadSvg(svgIconOnly, 'dentico-icon.svg')} className="gap-2" data-id="element-2529">
                <Download className="w-4 h-4" data-id="element-2530" />
                Download SVG
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}